import { render, staticRenderFns } from "./ProjectTableMitra.vue?vue&type=template&id=17d0ba95"
import script from "./ProjectTableMitra.vue?vue&type=script&lang=js"
export * from "./ProjectTableMitra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports